import { SystemBreakpoint } from './breakpoints';

export type SizeMap = {
  xxxs: string;
  xxs: string;
  xs: string;
  s: string;
  base: string;
  m: string;
  l: string;
  xl: string;
  xxl: string;
};

export type SystemSize = keyof SizeMap;
export type SystemSizeMap = {
  [key in SystemBreakpoint]: SizeMap;
};

const sizes: SystemSizeMap = {
  mobile: {
    xxxs: '2px',
    xxs: '10px',
    xs: '12px',
    s: '14px',
    base: '16px',
    m: '18px',
    l: '24px',
    xl: '32px',
    xxl: '54px',
  },
  tablet: {
    xxxs: '2px',
    xxs: '10px',
    xs: '12px',
    s: '14px',
    base: '16px',
    m: '18px',
    l: '24px',
    xl: '32px',
    xxl: '54px',
  },
  tabletLandscape: {
    xxxs: '2px',
    xxs: '10px',
    xs: '12px',
    s: '14px',
    base: '16px',
    m: '18px',
    l: '24px',
    xl: '32px',
    xxl: '54px',
  },
  desktop: {
    xxxs: '2px',
    xxs: '10px',
    xs: '12px',
    s: '14px',
    base: '16px',
    m: '18px',
    l: '24px',
    xl: '32px',
    xxl: '54px',
  },
};

export default sizes;
